/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_SourceInputs */

const en_pc_online_cmp_source = /** @type {(inputs: Pc_Online_Cmp_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Based on the PdfCraft README at github.com/storytold/pdfcraft and the messages in the 0.8.0 web build.`)
};

const zh_pc_online_cmp_source = /** @type {(inputs: Pc_Online_Cmp_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`依据 github.com/storytold/pdfcraft 的 README 以及 0.8.0 网页版中的界面文字整理。`)
};

/**
* | output |
* | --- |
* | "Based on the PdfCraft README at github.com/storytold/pdfcraft and the messages in the 0.8.0 web build." |
*
* @param {Pc_Online_Cmp_SourceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_source = /** @type {((inputs?: Pc_Online_Cmp_SourceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_SourceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_source(inputs)
	return zh_pc_online_cmp_source(inputs)
});
export { pc_online_cmp_source as "pc.online.cmp_source" }